import { Button } from '@astryxdesign/core/Button';
import { Card } from '@astryxdesign/core/Card';
import { Heading } from '@astryxdesign/core/Heading';
import { List, ListItem } from '@astryxdesign/core/List';
import { Text } from '@astryxdesign/core/Text';
import { VStack } from '@astryxdesign/core/VStack';
import { CaretRight } from '@phosphor-icons/react';
import type { Studio } from '@/api/schemas';
import { fmtDuration, fmtMoney } from '@/lib/format';

/** "Запись в студию": the shortest path — pick a service, then a time. */
export function BookingCard({ studio, onBook }: { studio: Studio; onBook: (serviceId?: string) => void }) {
  const top = studio.services.slice(0, 4);
  return (
    <VStack gap={3} as="section" aria-labelledby="book-heading">
      <Heading level={2} id="book-heading">
        Запись в студию
      </Heading>
      <Card>
        <VStack gap={3}>
          <Text color="secondary">Выберите услугу — покажем свободное время. Регистрация не нужна.</Text>
          <List hasDividers density="compact">
            {top.map((s) => (
              <ListItem
                key={s.id}
                label={s.name}
                description={fmtDuration(s.durationMin)}
                endContent={
                  <>
                    <Text weight="semibold" hasTabularNumbers>
                      {fmtMoney(s.priceCents, studio.currency, s.priceIsFrom)}
                    </Text>
                    <CaretRight size={16} aria-hidden />
                  </>
                }
                onClick={() => onBook(s.id)}
              />
            ))}
          </List>
          <Button label="Выбрать услугу и время" variant="primary" size="lg" width="100%" onClick={() => onBook()} />
        </VStack>
      </Card>
    </VStack>
  );
}
